export default class SenderName {

  private readonly _value: string;

  constructor(value: string) {
    this._value = value;
  }

  public isEqualTo(other: SenderName): boolean {
    return this.value === other?.value;
  }

  public get value(): string {
    return this._value;
  }

  public static get Prototype(): SenderName {
    return new SenderName("");
  }

  public fromJSON(value: string): SenderName {
    return new SenderName(value);
  }
  public toJSON(): string {
    return this.value;
  }
  public clone(): SenderName {
    return new SenderName(this.value);
  }
}
